//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadPicture from '@/components/uploadPicture/index';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { getToken } from '@/utils/auth';
import { uploader } from '@/utils/uploadCloud';
export default {
  name: 'name',
  props: {
    imageUrl: {
      type: [String, Boolean],
      require: false
    },
    user: {
      type: [String],
      require: ''
    },
    isUploadStatus: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  components: {
    uploadPicture: uploadPicture,
    ElImageViewer: ElImageViewer
  },
  data: function data() {
    return {
      src: null,
      uploadSize: 5,
      uploadImgLoading: false,
      dialogVisible: false,
      isImage: false,
      srcList: [],
      myHeaders: {
        authorization: 'Bearer ' + getToken()
      },
      uploadData: {}
    };
  },
  computed: {},
  methods: {
    //  开启弹窗
    beforeUpload: function beforeUpload() {
      this.dialogVisible = true;
    },
    // 获取弹窗
    getImage: function getImage(data) {
      this.$emit('update:imageUrl', data.att_dir);
      this.$emit('getImage', data.att_dir);
      this.handleClose();
    },
    // 关闭弹窗
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs.uploadPicture.getFileList('');
      this.$refs.uploadPicture.selectItem = [];
      this.$refs.uploadPicture.checkPicList = [];
    },
    // 查看图片
    handlePictureCardPreview: function handlePictureCardPreview() {
      this.srcList.push(this.imageUrl);
      this.isImage = true;
    },
    // 删除图片
    handleAvatar: function handleAvatar() {
      this.$emit('update:imageUrl', '');
    },
    // 上传文件方法
    uploadServerLog: function uploadServerLog(params) {
      var _this = this;
      this.percentShow = true;
      var file = params.file;
      var options = {
        way: 2,
        relation_type: '',
        relation_id: '',
        eid: ''
      };
      uploader(file, 0, 2, options).then(function (res) {
        // 获取上传文件渲染页面
        if (res.name) {
          _this.$emit('update:imageUrl', res.url);
          _this.$emit('getImage', res.url);
        }
      }).catch(function (err) {});
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
      this.srcList = [];
    }
  }
};